import React, { useState, useEffect } from "react";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import "./Modals.css";

const ActiveRecall = ({ selectedClassId, selectedUnitId, selectedUnitName, userId }) => {
  const [showOverlay, setShowOverlay] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [queue, setQueue] = useState([]);
  const [currentRecall, setCurrentRecall] = useState(null);

  // Lock scroll when overlay open
  useEffect(() => {
    document.body.style.overflow = showOverlay ? "hidden" : "";
    return () => (document.body.style.overflow = "");
  }, [showOverlay]);

  // Fetch recall prompts
  useEffect(() => {
    const fetchRecalls = async () => {
      if (!userId || !selectedClassId || !selectedUnitId) return;
      try {
        const db = getFirestore();
        const recallsRef = collection(
          db,
          "Users",
          userId,
          "Classes",
          selectedClassId,
          "Units",
          selectedUnitId,
          "ActiveRecall"
        );
        const snapshot = await getDocs(recallsRef);
        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          prompt: doc.data().prompt || "No prompt found",
        }));
        setQueue(data);
        setCurrentRecall(data.length > 0 ? data[0] : null);
      } catch (err) {
        console.error("🔥 Error fetching Active Recall prompts:", err);
      }
    };
    fetchRecalls();
  }, [userId, selectedClassId, selectedUnitId]);

  // Handle answer submission
  const handleSend = async () => {
    if (!input.trim() || !currentRecall) return;
    setMessages((prev) => [...prev, { sender: "user", text: input }]);
    const userAnswer = input;
    setInput("");

    try {
      const res = await fetch("http://localhost:8000/api/active-recall/grade", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId,
          classId: selectedClassId,
          unitId: selectedUnitId,
          recallId: currentRecall.id,
          userAnswer,
        }),
      });

      if (!res.ok) throw new Error(`Backend error: ${res.status}`);
      const data = await res.json();

      setMessages((prev) => [
        ...prev,
        { sender: "llm", text: data.feedback || "Answer evaluated." },
      ]);
    } catch (err) {
      console.error("❌ Active Recall grading failed:", err);
      setMessages((prev) => [
        ...prev,
        { sender: "llm", text: "⚠️ Error: Could not grade your answer." },
      ]);
    }
  };

  // Move to next recall
  const handleNext = () => {
    if (!currentRecall) return;
    const nextIndex = queue.findIndex((r) => r.id === currentRecall.id) + 1;
    if (nextIndex < queue.length) {
      setCurrentRecall(queue[nextIndex]);
    } else {
      setCurrentRecall(null);
    }
    setMessages([]);
    setInput("");
  };

  return (
    <>
      <div
        className="section-card"
        onClick={() => {
          if (!selectedClassId || !selectedUnitId) {
            alert("Please select a class and unit first.");
            return;
          }
          setShowOverlay(true);
        }}
      >
        <h2>Active Recall</h2>
        <p>Active Recall for {selectedUnitName || "no unit selected"}</p>
      </div>

      {showOverlay && (
        <div className="flashcard-fullscreen" role="dialog" aria-label="Active Recall popup">
          <button className="flashcard-close" onClick={() => setShowOverlay(false)}>
            ×
          </button>

          {/* Prompt */}
          <div className="flashcard-header">
            <h2>{currentRecall ? currentRecall.prompt : "No Active Recall prompts found."}</h2>
          </div>

          {/* Messages */}
          <div className="chat-window">
            {messages.length === 0 ? (
              <p className="flashcard-prompt">Type your answer below to begin.</p>
            ) : (
              messages.map((msg, idx) => (
                <div key={idx} className={`chat-message ${msg.sender}`}>
                  {msg.text}
                </div>
              ))
            )}
          </div>

          {/* Input */}
          <div className="chat-input">
            <input
              type="text"
              value={input}
              placeholder="Type your answer..."
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleSend();
              }}
            />
            <button onClick={handleSend}>Submit</button>
            <button onClick={handleNext} style={{ marginLeft: "8px" }}>
              Next
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ActiveRecall;
